import { LitElement, html } from 'lit';

import { customElement } from 'lit/decorators';

@customElement('error-403-page')
export class Error403Page extends LitElement {
    static amplitude_callsite: string = '403 Page';

    render() {
        return html`
            <error-page-fragment
                heading="Oops! You don’t have that level of access."
                description="You may need to log in first to see this map or the link you have could be broken."
            >
            </error-page-fragment>
        `;
    }
}
